var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stock-momentum-view"},[_c('StockMomentum')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }